var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 8.21254C3.50002 8.32555 3.53355 8.43601 3.59634 8.52996C3.65914 8.62391 3.74838 8.69713 3.85278 8.74037C3.95718 8.78362 4.07206 8.79493 4.1829 8.77289C4.29373 8.75085 4.39554 8.69645 4.47546 8.61656L7.33269 5.75932C7.43982 5.65216 7.5 5.50684 7.5 5.35531C7.5 5.20378 7.43982 5.05846 7.33269 4.9513L4.47546 2.09407C4.39554 2.01418 4.29373 1.95977 4.1829 1.93773C4.07206 1.91569 3.95718 1.92701 3.85278 1.97025C3.74838 2.01349 3.65914 2.08672 3.59634 2.18067C3.53355 2.27462 3.50002 2.38508 3.5 2.49808V8.21254Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/PlayButton.48f3bc6ecc7680698f06a8c2b7c40046.svg";
export { ForwardRef as ReactComponent };